// stores/itemStore.js
import { create } from "zustand";
import axios from "axios";
import authHeader from "../../services/auth-header";
import { APP_URL } from "../../services/http-common";
import useGlobalStore from "./globalStoreZs";

const URLEntityName = APP_URL + "chapter";

const useChapterStore = create((set, get) => ({
  chaptersZs: [],
  chapterZs: {},
  fetchChaptersZs: async (reportId) => {
    useGlobalStore.getState().setLoadingZs(true);
    set({ loading: true });
    try {
      const response = await axios.get(URLEntityName + "/report/" + reportId, {
        headers: authHeader(),
      });
      set({ chaptersZs: response.data });
    } catch (error) {
      console.error("Error fetching items", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },

  getChapterZs: async (id) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.get(URLEntityName + "/" + id, {
        headers: authHeader(),
      });
      set({
        chapterZs: response.data,
      });
    } catch (error) {
      console.error("Error fetching items", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },

  createChapterZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.post(URLEntityName, item, {
        headers: authHeader(),
      });
      //   await useFormInputesSubmissionStore.getState().getReportZs(item?.id);
      await useChapterStore.getState().fetchChaptersZs(item?.reportId);
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Rekordi u shtua me sukses!");
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  updateChapterZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.put(URLEntityName + "/" + item?.id, item, {
        headers: authHeader(),
      });
      //   await useFormInputesSubmissionStore.getState().getReportZs(item?.id);
      await useChapterStore.getState().fetchChaptersZs(item?.reportId);
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore
        .getState()
        .setMessageZs("Kapitulli u ndryshuar me sukses!");
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  deleteChapterZs: async (item) => {
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.delete(URLEntityName + "/" + item?.id, {
        headers: authHeader(),
      });
      await useChapterStore.getState().fetchChaptersZs(item?.reportId);
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Rekordi u fshi me sukses!");
    } catch (error) {
      console.error("Error delete ", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },
}));

export default useChapterStore;
